import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import fetch, { update } from '../../../Api/definitionCourseJobTitle';

const useCourse = ({ departmentId, jobTitleId }, setIsLoading) => {
  const history = useHistory();
  const [coursesByEnterprise, setCoursesByEnterprise] = useState([]);
  const [coursesByDepartment, setCoursesByDepartment] = useState([]);
  const [courses, setCourses] = useState([]);
  const [defaultSelectedIds, setDefaultSelectedIds] = useState([]);
  const [terminals, setTerminals] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch(departmentId, jobTitleId).then(data => {
      setTerminals(data.terminals);
      setCourses(data.courseByJobTitle);
      setCoursesByDepartment(data.courseByDepartment);
      setCoursesByEnterprise(data.courseByEnterprise);
      setCategories(data.categories);
      setIsLoading(false);
      const idArr = [];
      data.courseByJobTitle.forEach((courseArray, index) => {
        // checks 'isChecked' value
        if (courseArray[courseArray.length - 1]) {
          idArr.push(courseArray[5]);
        }
      });
      setDefaultSelectedIds(Array.from(idArr));
    });
  }, []);

  const saveCourses = courseData => {
    update(courseData, jobTitleId)
      .then(() => {
        history.push({
          pathname: '/definicion',
          state: {
            update: true,
          },
        });
      })
      .catch(err => err);
  };

  return {
    courses,
    setCourses,
    terminals,
    categories,
    saveCourses,
    coursesByEnterprise,
    coursesByDepartment,
    defaultSelectedIds,
  };
};

export default useCourse;
